import {NgModule} from '@angular/core';
import {PreloadAllModules, RouterModule, Routes} from '@angular/router';

const routes: Routes = [
    {
        path: '',
        redirectTo: 'user/signup',
        pathMatch: 'full'
    },
    {path: 'user', loadChildren: './pages/user/user.module#UserPageModule'},
    {path: 'child', loadChildren: './pages/child/child.module#ChildPageModule'},
    {path: 'assessment', loadChildren: './pages/assessment/assessment.module#AssessmentPageModule'},
    {path: 'program', loadChildren: './pages/program/program.module#ProgramPageModule'},
    {path: 'common', loadChildren: './pages/common/common.module#ScopeUtilsModule'},
    {path: 'scope', loadChildren: './pages/links/links.module#LinksModule'},
    {path: 'editt', loadChildren: './pages/editt/editt.module#EdittModule'},
    {path: 'payment', loadChildren: './pages/payflow/payflow.module#ProgramPageModule'}
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {preloadingStrategy: PreloadAllModules})
    ],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
